import { writable } from 'svelte/store'

/** @type {PresentUsersStore} */
export const present_users = writable([])
